import lockIcon from "@ms/lock.svg?raw";
import publicIcon from "@ms/public.svg?raw";
import { Icon } from "@ui/Icon";
import "./PrivatePublicIcon.css";

export const PrivatePublicIcon = (props: { privacy: string }) => {
	return (
		<div class={`gvtui-board-item-privacy ${props.privacy}`}>
			{props.privacy === "private" ? (
				<Icon icon={lockIcon} />
			) : (
				<Icon icon={publicIcon} />
			)}
		</div>
	);
};
